<template>
  <div class="home-header">
    <h1 class="home-header-logo" @click="onClickLogo">日志服务平台</h1>
    <div class="home-header-user">
      <div class="home-header-user-wrapper">
        <img class="home-header-user-icon" src="@/assets/icon/user-icon.png" />
      </div>
      <div class="home-header-user-info">
        <p class="home-header-user-info-name">用户名：{{ $store.state.user.userInfo.name }}</p>
        <p class="home-header-user-info-log_out">
          <a @click="onLogOut">退出</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Permission from '../../utils/Permission';

export default {
  name: 'HomeHeader',

  methods: {
    onClickLogo() {
      this.$router.push({ name: 'Index' });
    },
    onLogOut() {
      Permission.logout();
    }
  }
};
</script>

<style lang="scss" scoped>
$height-home-header: 60px;

.home-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  background-color: #20242d;
  height: $height-home-header;
  line-height: $height-home-header;
  padding-left: 24px;

  &-logo {
    color: #fff;
    font-size: 20px;
    font-weight: normal;
    letter-spacing: 2px;
    user-select: none;
    cursor: pointer;
    margin: 0;
    padding: 0;
    display: inline-block;
  }

  &-user {
    width: 90px;
    height: $height-home-header;
    position: relative;

    &-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      background-color: #20242d;
    }

    &:hover {
      background-color: #1bbcf3;
      cursor: pointer;

      .home-header-user-info {
        display: block;
      }
    }

    &-icon {
      width: 27px;
      vertical-align: top;
    }

    &-info {
      display: none;
      position: absolute;
      top: $height-home-header;
      right: 0;
      z-index: 9999;
      width: 230px;
      margin: 0;
      font-size: 14px;
      border: 0;
      border-radius: 0;
      color: #fff;
      background-color: #232026;

      &-name {
        display: flex;
        align-items: center;
        height: 54px;
        padding: 0 20px;
      }

      &-log_out {
        height: 40px;
        line-height: 40px;
        padding: 0 20px !important;
        text-align: center;
        background-color: #36313a !important;
        color: #00a0ff;
      }
    }
  }
}
</style>
